module.exports = __webpack_public_path__ + "img/slider-22.409645ad.jpg";